export const TEAM = [
  {
    label: "Pakistan",
    value: "Pakistan",
    imgSrc: "/images/pak2.png",
  },
  {
    label: "India",
    value: "India",
    imgSrc: "/images/india.png",
  },
  {
    label: "Australia",
    value: "Australia",
    imgSrc: "/images/aus.png",
  },
  {
    label: "England",
    value: "England",
    imgSrc: "/images/england.png",
  },
  {
    label: "South Africa",
    value: "South Africa",
    imgSrc: "/images/southAfrica.png",
  },
  {
    label: "West Indies",
    value: "West Indies",
    imgSrc: "/images/westindies.png",
  },
  {
    label: "New Zealand",
    value: "New Zealand",
    imgSrc: "/images/newzealand.png",
  },
  {
    label: "Sri Lanka",
    value: "Sri Lanka",
    imgSrc: "/images/sriLanka.png",
  },
  {
    label: "Bangladesh",
    value: "Bangladesh",
    imgSrc: "/images/bangladesh.png",
  },
  {
    label: "Afghanistan",
    value: "Afghanistan",
    imgSrc: "/images/afghanistan.png",
  },
  {
    label: "Zimbabwe",
    value: "Zimbabwe",
    imgSrc: "/images/zimbabwe.png",
  },
];

export const FORMAT = [
  {
    label: "T20",
    value: "t20",
  },
  { label: "ODI", value: "odi" },
  { label: "Test", value: "test" },
];

export const STATRELEVANCE = [
  {
    label: "By Time Period",
    value: "timePerion",
  },
  { label: "By Last Matches", value: "lastMatches" },
];

export const LIMIT = [
  {
    label: 5,
    value: 5,
  },
  { label: 10, value: 10 },
  { label: 15, value: 15 },
];

export const PITCH = [
  {
    label: "Neutral",
    value: "neutral",
  },
  { label: "Dusty", value: "spin" },
  { label: "Green", value: "fast" },
];

export const TYPE = [
  {
    label: "Batting",
    value: "batting",
  },
  { label: "Bowling", value: "bowling" },
  { label: "Balanced", value: "balanced" },
];
